export default __webpack_public_path__ + "static/media/sectionImg-mobile.b3a60240.png";